import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

interface SupportContact {
  nameKey: string;
  email: string;
}

@Component({
    selector: 'app-about-fenaco-id',
    templateUrl: './about-fenaco-id.component.html',
    styleUrls: ['./about-fenaco-id.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AboutFenacoIdComponent implements OnInit {
  supportContacts: SupportContact[] = [
    {
      nameKey: 'landingPage.forthSection.contacts.landiAgrar',
      email: 'webshop.agrar@fenaco.com',
    },
    {
      nameKey: 'landingPage.forthSection.contacts.agrolaEmob',
      email: 'emobility@agrola.ch',
    },
    {
      nameKey: 'landingPage.forthSection.contacts.agrolaEnergyClub',
      email: 'energyclub@agrola.ch',
    },
    {
      nameKey: 'landingPage.forthSection.contacts.barto',
      email: 'info@barto.ch',
    },
  ];

  isDropdownOpen = false;

  constructor(public translate: TranslateService) {}

  scrollTop() {
    window.scrollTo(0, 0);
  }

  ngOnInit() {
    this.scrollTop();
  }

  sendEmail(email: string) {
    window.location.href = `mailto:${email}`;
  }
}
